import React from 'react'
import { Container } from './styles'
import { getQuantitativePropertyReferenceValue } from '~/utils'

interface IReferenceValueProps {
  lowerValue?: number
  upperValue?: number
}

export const ReferenceValue = (props: IReferenceValueProps): JSX.Element => {
  const { lowerValue, upperValue } = props

  const reference = getQuantitativePropertyReferenceValue({ lowerValue, upperValue, label: 'Ref.:' })
  const isReferenceEmpty = reference === ''
  if (isReferenceEmpty) return <></>

  return <Container data-testid="quantitative-reference-value">{reference}</Container>
}
